export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue',
      neutral: 'coolGray'
    },

    button: {
      slots: {
        base: 'justify-center'
      },

      variants: {
        variant: {
          solid:
            'dark:hover:bg-{color}-400 hover:opacity-80 transition-all dark:text-white'
        }
      },
      compoundVariants: [
        {
          color: 'info',
          variant: 'solid',
          class: 'bg-primary-500 hover:bg-primary-500 disabled:bg-primary-500'
        },
        {
          color: 'info',
          variant: 'outline',
          class: 'bg-transparent border border-primary-500 text-white'
        },
        {
          color: 'error',
          variant: 'solid',
          class: 'bg-red-500 hover:bg-red-500'
        }
      ]
    },

    selectMenu: {
      slots: {
        content: 'z-50 bg-neutral-900 cursor-pointer',
        trailingIcon:
          'group-data-[state=open]:rotate-180 transition-transform duration-200'
      },
      variants: {
        variant: {
          outline: 'bg-transparent'
        }
      }
    }
  }
})
